const headerLength = 512;
const entryLength = 12;
/**
 * Reads and validates the subfile directory of an XYXY file. It is announced
 * by a non-zero `fnpts` (its offset) and lists where each subfile is: GRAMS
 * moves subfiles to the end of the file when they grow, so the sequential
 * layout can be stale.
 * @param buffer - SPC buffer.
 * @param offset - `fnpts`, the offset of the directory (0 when absent).
 * @param count - number of subfiles (`fnsub`).
 * @param logOffset - `flogoff`.
 * @param context - receives a warning when the directory is not usable.
 * @returns The entries, or `undefined` when there is no valid directory.
 */
export function readDirectory(buffer, offset, count, logOffset, context) {
    if (offset === 0)
        return undefined;
    const end = offset + entryLength * count;
    if (offset < headerLength ||
        end > buffer.length ||
        (logOffset !== 0 && end > logOffset)) {
        context.warn(`The subfile directory at offset ${offset} does not fit in the file; subfiles read sequentially`);
        return undefined;
    }
    buffer.seek(offset);
    const entries = [];
    for (let i = 0; i < count; i++) {
        const position = buffer.readUint32();
        const size = buffer.readUint32();
        const time = buffer.readFloat32();
        if (position < headerLength || position + 32 > buffer.length) {
            context.warn(`Subfile directory entry ${i + 1} of ${count} points outside the file (${position}); subfiles read sequentially`);
            return undefined;
        }
        entries.push({ position, size, time });
    }
    return entries;
}
//# sourceMappingURL=directory.js.map